import { Component, Input, SimpleChanges } from '@angular/core';
import { LoadingController} from 'ionic-angular';

/**
 * Generated class for the LoaderTwoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'loader-two',
  templateUrl: 'loader-two.html'
})
export class LoaderTwoComponent {

  @Input() isShowLoader: boolean;
  text: string;
  loader : any;

  constructor(public loadingCtrl : LoadingController) {
    console.log('Hello LoaderTwoComponent Component');
    this.text = 'Hello World';
  }

  ngOnInit() {
   
    
  }

  ngOnChanges(changes: SimpleChanges ) {
    console.log("Position is", changes.position)
    if (changes.isShowLoader.currentValue == true) {
      if(this.loader == null){
        this.loader = this.loadingCtrl.create({
          content: "Please Wait",
        });
        this.loader.present();
      }
    }
    else{
      try{
        if(this.loader != null){
          this.loader.dismiss();
           this.loader = null;
        }
      }catch(err){

      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/loader-two/loader-two.ts